module.exports={
  "color": [
    {
      "label": "Pure White",
      "value": "1",
      "wood": "purewood",
      "image": "1.jpg"
    },
    {
      "label": "Taupe Grey",
      "value":  "80",
      "wood": "purewood",
      "image": "80.jpg"
    },
    {
      "label": "Dark Mahogany",
      "value":  "233",
      "wood": "purewood",
      "image": "233.jpg"
    },
    {
      "label": "Matte Black",
      "value":  "246",
      "wood": "purewood",
      "image": "246.jpg"
    },
    {
      "label": "Silk White",
      "value":  "3",
      "wood": "purewood",
      "image": "3.jpg"
    },
    {
      "label": "Pearl",
      "value":  "6",
      "wood": "purewood",
      "image": "6.jpg"
    },
    {
      "label": "Crisp Linen",
      "value":  "12",
      "wood": "purewood",
      "image": "12.jpg"
    },
    {
      "label": "String",
      "value":  "19",
      "wood": "purewood",
      "image": "19.jpg"
    },
    {
      "label": "Sea Mist",
      "value":  "32",
      "wood": "purewood",
      "image": "32.jpg"
    },
    {
      "label": "Stone Grey",
      "value":  "49",
      "wood": "purewood",
      "image": "49.jpg"
    },
    {
      "label": "Brown Grey",
      "value":  "51",
      "wood": "purewood",
      "image": "51.jpg"
    },
    {
      "label": "Clay",
      "value":  "53",
      "wood": "purewood",
      "image": "53.jpg"
    },
    {
      "label": "Rustic Grey",
      "value":  "108",
      "wood": "purewood",
      "image": "108.jpg"
    },
    {
      "label": "Weathered Teak",
      "value":  "109",
      "wood": "purewood",
      "image": "109.jpg"
    },
    {
      "label": "Limed White",
      "value":  "110",
      "wood": "purewood",
      "image": "110.jpg"
    },
    {
      "label": "Taupe",
      "value":  "114",
      "wood": "purewood",
      "image": "114.jpg"
    },
    {
      "label": "Oak Mantel",
      "value":  "204",
      "wood": "purewood",
      "image": "204.jpg"
    },
    {
      "label": "Cherry",
      "value":  "211",
      "wood": "purewood",
      "image": "211.jpg"
    },
    {
      "label": "Dark Teak",
      "value":  "212",
      "wood": "purewood",
      "image": "212.jpg"
    },
    {
      "label": "Cordovan",
      "value":  "215",
      "wood": "purewood",
      "image": "215.jpg"
    },
    {
      "label": "Mahogany",
      "value":  "219",
      "wood": "purewood",
      "image": "219.jpg"
    },
    {
      "label": "New Ebony",
      "value":  "220",
      "wood": "purewood",
      "image": "220.jpg"
    },
    {
      "label": "Black Walnut",
      "value":  "221",
      "wood": "purewood",
      "image": "221.jpg"
    },
    {
      "label": "Red Oak",
      "value":  "227",
      "wood": "purewood",
      "image": "227.jpg"
    },
    {
      "label": "Old Teak",
      "value":  "230",
      "wood": "purewood",
      "image": "230.jpg"
    },
    {
      "label": "Wenge",
      "value":  "237",
      "wood": "purewood",
      "image": "237.jpg"
    },
    {
      "label": "Truffle",
      "value":  "6958",
      "wood": "fauxwood",
      "image": "6958.jpg"
    },
    {
      "label": "Taupe Grey",
      "value":  "6103",
      "wood": "fauxwood",
      "image": "6103.jpg"
    },
    {
      "label": "Storm Grey",
      "value":  "6101",
      "wood": "fauxwood",
      "image": "6101.jpg"
    },
    {
      "label": "Silk White",
      "value":  "6017",
      "wood": "fauxwood",
      "image": "6017.jpg"
    },
    {
      "label": "Sea Mist",
      "value":  "6102",
      "wood": "fauxwood",
      "image": "6102.jpg"
    },
    {
      "label": "Pure White",
      "value":  "6016",
      "wood": "fauxwood",
      "image": "6016.jpg"
    },
    {
      "label": "Pearl",
      "value":  "6019",
      "wood": "fauxwood",
      "image": "6019.jpg"
    },
    {
      "label": "Old Teak",
      "value":  "6922",
      "wood": "fauxwood",
      "image": "6922.jpg"
    },
    {
      "label": "Natural Oak",
      "value":  "6936",
      "wood": "fauxwood",
      "image": "6936.jpg"
    },
    {
      "label": "Mist",
      "value":  "6957",
      "wood": "fauxwood",
      "image": "6957.jpg"
    },
    {
      "label": "Limed White",
      "value":  "6933",
      "wood": "fauxwood",
      "image": "6933.jpg"
    },
    {
      "label": "Grey",
      "value":  "6938",
      "wood": "fauxwood",
      "image": "6938.jpg"
    },
    {
      "label": "Granite",
      "value":  "6959",
      "wood": "fauxwood",
      "image": "6959.jpg"
    },
    {
      "label": "Driftwood",
      "value":  "6937",
      "wood": "fauxwood",
      "image": "6937.jpg"
    },
    {
      "label": "Designer White",
      "value":  "6051",
      "wood": "fauxwood",
      "image": "6051.jpg"
    },
    {
      "label": "Crisp Linen",
      "value":  "6057",
      "wood": "fauxwood",
      "image": "6057.jpg"
    },
    {
      "label": "Chestnut",
      "value":  "6921",
      "wood": "fauxwood",
      "image": "6921.jpg"
    },
    {
      "label": "Bright White",
      "value":  "6018",
      "wood": "fauxwood",
      "image": "6018.jpg"
    },
    {
      "label": "Black Walnut",
      "value":  "6923",
      "wood": "fauxwood",
      "image": "6923.jpg"
    }
  ],
  "wood": [
    {
      "label": "Pure Wood",
      "value": "purewood"
    },
    {
      "label": "Faux Wood",
      "value": "fauxwood"
    }
  ],
  "slat_size": [
    {
      "label": "50mm",
      "value": "50mm"

    },
    {
      "label": "64mm",
      "value": "64mm"
    }
  ],
  "tape_or_cord": [
    {
      "label": "Tape",
      "value": "tape"

    },
    {
      "label": "Cord",
      "value": "cord"
    }
  ],
  "tape_color": [
    {
      "label": "White",
      "value": "white"
    },
    {
      "label": "Black",
      "value": "black"
    }
  ],
  "fitting_position": [
    {
      "label": "Inside",
      "value": "inside"
    },
    {
      "label": "Outside",
      "value": "outside"
    }
  ],
  "lift_cord_position": [
    {
      "label": "Left",
      "value": "left"
    },
    {
      "label": "Right",
      "value": "right"
    }
  ],
  "tilt_cord_position": [
    {
      "label": "Left",
      "value": "left"
    },
    {
      "label": "Right",
      "value": "right"
    }
  ]
}